import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { scrollToId } from "@/components/SmoothScroll";
import BlogPage from "@/pages/BlogPage";
import PostPage from "@/pages/PostPage";
import AdminPage from "@/pages/AdminPage";
import { LanguageProvider, useLang } from "@/context/LanguageContext";
import { YouTubeProvider } from "@/context/YouTubeContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { PeopleStage } from "@/components/PeopleStage";
import { Interviews } from "@/components/Interviews";
import { GroundReports } from "@/components/GroundReports";
import { Politics } from "@/components/Politics";
import { FeaturedVideo } from "@/components/FeaturedVideo";
import { LatestWriting } from "@/components/LatestWriting";
import { About } from "@/components/About";
import { Stats } from "@/components/Stats";
import { SocialSection } from "@/components/SocialSection";
import { Footer } from "@/components/Footer";

const Page = () => {
  const { lang } = useLang();
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const timer = setTimeout(() => scrollToId(id), 350);
    return () => clearTimeout(timer);
  }, [hash]);
  return (
    <div className="grain bg-ink font-body text-cream" lang={lang === "te" ? "te" : "en"}>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <PeopleStage />
        <Interviews />
        <GroundReports />
        <Politics />
        <FeaturedVideo />
        <LatestWriting />
        <About />
        <Stats />
        <SocialSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <LanguageProvider>
        <YouTubeProvider>
          <SmoothScroll>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Page />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<PostPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<Page />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="bottom-right" theme="dark" />
          </SmoothScroll>
        </YouTubeProvider>
      </LanguageProvider>
    </MotionConfig>
  );
}

export default App;
